const CHUNK_LOAD_INTERCEPTOR_GLOBAL = '__chunkLoadInterceptor__';
export const makeChunkLoadInterceptorRegistrar = (host)=>(interceptor)=>{
        Reflect.set(host, CHUNK_LOAD_INTERCEPTOR_GLOBAL, interceptor);
    };
